module.exports = __webpack_public_path__ + "898871618bd98fed453bed99f14f0524.glb";